import t from"styled-components";const e=t("div")`
  display: flex;
  align-items: center;
  margin-top: ${({theme:t})=>t.spacing(10)};
  margin-right: ${({theme:t})=>t.spacing(0)};
  margin-bottom: ${({theme:t,hasFooter:e})=>e?"0":t.spacing(30)};
  ${({theme:t})=>t.breakpoints.down("md")} {
    flex-direction: column;
    align-items: flex-start;
  }

  .MuiButton-root {
    font-weight: ${({theme:t})=>t.typography.button.fontWeight};
  }

  .MuiButton-root:nth-of-type(2) {
    margin-left: ${({theme:t})=>t.spacing(5)};
  }
  ${({theme:t})=>t.breakpoints.down("md")} {
    flex-direction: column;
    justify-content: center;
    margin-right: ${({theme:t})=>t.spacing(0)};

    .MuiButton-root:nth-of-type(2) {
      margin-top: ${({theme:t})=>t.spacing(5)};
      margin-left: ${({theme:t})=>t.spacing(0)};
    }
  }
`;export{e as CTAButtonsDiv};
//# sourceMappingURL=styles.js.map
